module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/~/core-js/modules/_fails.js
// module id = 7
// module chunks = 0